import { render, staticRenderFns } from "./gaoyahuilu.vue?vue&type=template&id=4c5bdfa7&scoped=true&"
import script from "./gaoyahuilu.vue?vue&type=script&lang=js&"
export * from "./gaoyahuilu.vue?vue&type=script&lang=js&"
import style0 from "./gaoyahuilu.vue?vue&type=style&index=0&id=4c5bdfa7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5bdfa7",
  null
  
)

export default component.exports